import { Controller } from '@hotwired/stimulus'
import { useIntersection } from 'stimulus-use'

export default class extends Controller {
    connect() {   
        const slot = this.#getSlot()
        
        if (slot) {
            adition.srq.push(api => api.renderSlot(slot))
        }

        useIntersection(this)
    }

    appear(entry, observer) {
        observer.unobserve(entry.target)

        const slot = this.#getSlot()
        
        if (slot) {
            adition.srq.push(api => api.load([slot]).completeRendering([slot]))
        }
    }

    #getSlot() {
        if (!window.adition || !window.aditionSetup) {
            return null
        }

        const slot = this.element.id

        if (!window.aditionSetup[slot]) {
            return null
        }

        return slot
    }
}
